import React from 'react';

/**
 * Branded header shown on all customer-facing feedback pages.
 * Uses branding from useBranding hook.
 */
export default function BrandedHeader({ branding, billId, subtitle, recipientName }) {
  const { businessName, tagline, logoUrl, gradient, buttonTextColor } = branding;

  return (
    <div
      style={{
        background: gradient,
        borderRadius: 16,
        padding: '28px 24px',
        textAlign: 'center',
        marginBottom: 20,
        color: buttonTextColor || '#fff',
      }}
    >
      {/* Logo or emoji fallback */}
      {logoUrl ? (
        <img
          src={logoUrl}
          alt={businessName}
          style={{
            height: 64,
            maxWidth: 180,
            objectFit: 'contain',
            borderRadius: 10,
            marginBottom: 12,
            background: 'rgba(255,255,255,0.15)',
            padding: '6px 12px',
          }}
        />
      ) : (
        <div style={{ fontSize: 44, marginBottom: 10 }}>💬</div>
      )}

      <h2 style={{ color: buttonTextColor || '#fff', fontSize: 22, marginBottom: 4 }}>
        {businessName}
      </h2>

      {tagline && (
        <p style={{ opacity: 0.8, fontSize: 13, margin: '4px 0 0' }}>{tagline}</p>
      )}

      {(subtitle || billId || recipientName) && (
        <div style={{ marginTop: 10, opacity: 0.75, fontSize: 13, display: 'flex', justifyContent: 'center', gap: 14, flexWrap: 'wrap' }}>
          {recipientName && <span>👋 Hi, {recipientName}!</span>}
          {subtitle && <span>{subtitle}</span>}
          {billId && <span>🧾 Bill: {billId}</span>}
        </div>
      )}
    </div>
  );
}
